import { STYLE_TYPE, SHOW_TYPE } from "../../types/fe";
export var LIST_STATUS;
(function (LIST_STATUS) {
    LIST_STATUS[LIST_STATUS["SUCCESS"] = 1] = "SUCCESS";
    // 正常态
    LIST_STATUS[LIST_STATUS["LOADING"] = 2] = "LOADING";
    // 加载态
    LIST_STATUS[LIST_STATUS["ERROR"] = 3] = "ERROR"; // 错误态
})(LIST_STATUS || (LIST_STATUS = {}));
export var LOAD_MORE_STATUS;
(function (LOAD_MORE_STATUS) {
    LOAD_MORE_STATUS[LOAD_MORE_STATUS["SUCCESS"] = 1] = "SUCCESS";
    // 正常态
    LOAD_MORE_STATUS[LOAD_MORE_STATUS["LOADING"] = 2] = "LOADING";
    // 加载态
    LOAD_MORE_STATUS[LOAD_MORE_STATUS["ERROR"] = 3] = "ERROR"; // 错误态
})(LOAD_MORE_STATUS || (LOAD_MORE_STATUS = {}));
// 渲染配置映射
export const RENDER_CONFIG_MAP = {
    [`${STYLE_TYPE.COMPREHENSIVE_CARD}`]: {
        styleType: STYLE_TYPE.COMPREHENSIVE_CARD,
        showType: SHOW_TYPE.VERTICAL_DOUBLE,
        className: 'list-container__item--vertical'
    },
    [`${STYLE_TYPE.COMMON}_${SHOW_TYPE.VERTICAL_DOUBLE}`]: {
        styleType: STYLE_TYPE.COMMON,
        showType: SHOW_TYPE.VERTICAL_DOUBLE,
        className: 'list-container__item--vertical'
    },
    [`${STYLE_TYPE.COMMON}_${SHOW_TYPE.HORIZONTAL}`]: {
        styleType: STYLE_TYPE.COMMON,
        showType: SHOW_TYPE.HORIZONTAL,
        className: 'list-container__item--horizontal',
        containerProps: {
            horizontal: true,
            showsHorizontalScrollIndicator: false,
            className: 'list-container--success-horizontal-scroll'
        }
    }
};
